module.exports = __webpack_public_path__ + "img/buildings.d915de33.svg";